import { z } from 'zod';

export const MANUAL_MEMORY_ENTRY_POINTS = [
  'platform_application',
  'platform_endpoint',
  'torch_application',
  'torch_endpoint',
  'torch_preference',
  'torch_chat_preference',
  'copilot_security_fact',
  'copilot_user_preference',
  'api_conversation_event',
] as const;

export const AUTOMATIC_MEMORY_ENTRY_POINTS = [
  'continual_learning_application',
  'continual_learning_endpoint',
  'attack_learning_application',
  'attack_learning_endpoint',
] as const;

export const SYSTEM_MEMORY_ENTRY_POINTS = [
  'endpoint_merge',
  'har_reassociate',
  'legacy_agentcore',
] as const;

export const ManualMemoryEntryPointSchema = z.enum(MANUAL_MEMORY_ENTRY_POINTS);

export const MemoryEntryPointSchema = z.enum([
  ...MANUAL_MEMORY_ENTRY_POINTS,
  ...AUTOMATIC_MEMORY_ENTRY_POINTS,
  ...SYSTEM_MEMORY_ENTRY_POINTS,
]);

export type ManualMemoryEntryPoint = z.infer<
  typeof ManualMemoryEntryPointSchema
>;

export type MemoryEntryPoint = z.infer<typeof MemoryEntryPointSchema>;
